export default __webpack_public_path__ + "static/media/scene_5.b22df5d0.png";